import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { zustandMMKVStorage } from './utils/commonStoreUtils';

// DEV/QA card-add refusal trigger, set from DevScreen and read at card-add
// submit (native). null = no injection. The TEST-only environment gate in
// useAdyenCardAdd is what keeps this inert in production. Persisted so the
// selection survives an app restart mid-test. See utils/qaRefusalOptions.
type QaRefusalState = {
  token: string | null;
  setToken: (token: string | null) => void;
};

export const useQaRefusalStore = create<QaRefusalState>()(
  persist(
    (set) => ({
      token: null,
      setToken: (token) => set({ token }),
    }),
    {
      name: 'qa-refusal-storage',
      storage: createJSONStorage(() => zustandMMKVStorage),
    }
  )
);
